import axios from 'axios';
import { API_DOMAIN } from '@/constants';

function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0; // Generate a random number between 0 and 15
    const v = c === 'x' ? r : (r & 0x3 | 0x8); // For 'y', ensure the first two bits are 10
    return v.toString(16); // Convert to hexadecimal
  });
}

const apiClient = axios.create({
  baseURL: API_DOMAIN,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  timeout: 10000,
});

if (process.env.NODE_ENV === 'development') {
  apiClient.defaults.headers['x-api-key'] = process.env.VUE_APP_EVENT_API_KEY;
}

export default {
  getEvent(eventId) {
    return apiClient.get(`/event/metadata?eventId=${  eventId}`);
  },

  getMetadataEvent(eventId) {
    return apiClient.get(`/event/metadata?eventId=${  eventId}`);
  },

  getChannelsEvent(eventId, securityCode) {
    return apiClient.get(`/event/channels?id=${generateUUID()}&eventId=${  eventId}`, {
      headers: {
        'event-security-code': btoa(securityCode),
      },
    });
  },
};
